<template>
  <div class='at-infobox mt-0'>
    <form @submit.prevent="submit()" class="form-styled-3">
      <div class="form-group col-md-8">
        <label>Invite your friend</label>
        <input type="email" v-model="email" class="form-control" 
          placeholder="myfriend@mail.com" required />
        <small class="text-danger" v-if="errors.email">
          {{ errors.email[0] }}
        </small>
      </div>
      <div class="form-group col-md-8">
        <button type="submit" class="at-submitbtn">Invite Friend</button>
      </div>
    </form>
  </div>
</template>

<script>
import { authRequest } from '../../app/helpers';
import toastr from 'toastr';

export default {
  data() {
    return {
      errors: {},
      email: '',
    }
  },


  methods: {
    async submit() {
      const { email } = this.$data;
      this.errors = {};

      const req = await authRequest(this.$router, '/user/invite_friend', {
          email,
        }, 'post');

      if (req.status) {
        toastr.success(req.message);

        this.email = '';
      } else {
        this.errors = req.errors || {};
        toastr.error(req.message);
      }
    }
  }
}
</script>